let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jXt4a")).then(() => parcelRequire('eaL12'));